import request from 'utils/request'

// MCBHS151初期化
export const getMCBHS151InitRequest = () => 
request({
  url: '/MCBHS151/init',
  method: 'post',
})

